<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="agent-type-list content-wrapper">
      <div class="page-header">{{ $t('agentType') }}</div>
      <div>
        <el-row>
          <el-col :span="4">
            <el-input :placeholder="$t('keyword')"
                      @input="isSearching = true"
                      v-model="keyword"></el-input>
          </el-col>
          <el-col :span="20" style="text-align: right;">
            <router-link to="agent-type/add" style="float: right">
              <el-button type="primary" icon="el-icon-plus"> {{ $t('newAgentType') }}</el-button>
            </router-link>
          </el-col>
        </el-row>
        <div style="margin-top: 25px">
          <el-table
            id="agent-type-list-table"
            :data="agentTypeListDataSource"
            v-loading="isSearching"
            header-row-class-name="table-header-color"
            style="width: 100%">
            <el-table-column
              :label="$t('type')">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column
              :label="$t('description')">
              <template slot-scope="scope">{{ scope.row.detail }}</template>
            </el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" icon="el-icon-edit" plain circle @click="onEditButtonClick(scope.row)"></el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" plain circle @click="onRemoveButtonClick(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/AgentType/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import SettingAgentTypeApi from '@/api/setting/agent-type-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import { filterDataByKeyword } from '@/services/general-service'
import { debounce } from 'lodash'

export default {
  name: 'SettingAgentTypeList',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  watch: {
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this.getAgentTypeListDataSource()
      }
    }
  },
  data () {
    return {
      isLoading: true,
      keyword: '',
      isSearching: false,
      agentTypeList: [],
      agentTypeListDataSource: []
    }
  },
  created: async function () {
    try {
      this.isLoading = true
      this.agentTypeList = await SettingAgentTypeApi.list()
      this.getAgentTypeListDataSource()
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  methods: {
    getAgentTypeListDataSource: function () {
      const searchKeys = ['name', 'detail']
      const filteredSalePersonList = filterDataByKeyword(this.agentTypeList, this.keyword, searchKeys)
      const sortedList = filteredSalePersonList.sort((a, b) => {
        return (a.name > b.name) ? 1 : -1
      })
      this.agentTypeListDataSource = [...sortedList]
    },
    onEditButtonClick: function (agentType) {
      this.$router.push({
        name: 'SettingAgentTypeEdit',
        params: {
          agentType: agentType
        }
      })
    },
    onRemoveButtonClick: async function (agentType) {
      const confirmMessage = this.$t('confirmRemoveAgentTypeMessage', {
        name: agentType.name
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      this.removeAgentType(agentType.id)
    },
    removeAgentType: async function (id) {
      try {
        this.startLoading()

        await SettingAgentTypeApi.remove(id)
        this.agentTypeList = this.agentTypeList.filter(item => item.id !== id)
        this.getAgentTypeListDataSource()

        const notificationTitle = this.$t('removeAgentTypeSuccess')
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    }
  }
}
</script>

<style scoped>
  #agent-type-list-table {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 5px;
    box-shadow: 0px 3px 5px 1px #eeeeee;
  }
  .el-table th {
    background-color: #eeeeee;
  }
  .el-form > div {
    text-align: left;
  }
</style>
